import get from "lodash/get";

export default {
  getAll(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/")
        .then((response) => {
          context.commit("setCourses", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  get(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/course/${id}`)
        .then((response) => {
          context.commit("setCourse", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  getForPreview(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/course/${id}`)
        .then((response) => {
          context.commit("setPreviewCourse", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  getMasters(context, params) {
    const query_string = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/teachers?${query_string}`)
        .then(({ data: { count, results, total } }) => {
          context.commit("setMasters", results);
          resolve({ count, results, total });
        })
        .catch(reject);
    });
  },

  getMasterCourses(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/?teachers=${id}`)
        .then((response) => {
          context.commit("setMasterCourses", response.data.results);
          resolve(response.data.results);
        })
        .catch(reject);
    });
  },

  getCategories(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/categories?limit=100")
        .then((response) => {
          context.commit("setCategories", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getCoursesByCollection(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/?collection=${id}`)
        .then((response) => {
          context.commit("setCoursesCollection", { ...response.data, id });
          resolve(response.data.results);
        })
        .catch(reject);
    });
  },
  getCurrentCategoryCourses(context, id) {
    let paramName = Array.isArray(id) ? "categories__in" : "categories";
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/?${paramName}=${id}`)
        .then((response) => {
          // let coursesCateg = response.data.results.filter(
          //   (course) => course.category.id == id
          // );
          context.commit("setCategoryCoursesShowing", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getBannerCourses(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/banners-courses")
        .then((response) => {
          context.commit("setBannerCourses", response.data.results);
          resolve(response.data.results);
        })
        .catch(reject);
    });
  },

  getDetails(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/${id}`)
        .then((response) => {
          // context.commit("setCourse", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  setProgress(context, data) {
    return new Promise((resolve, reject) => {
      window.axios.post("/courses/progress", data).then(resolve).catch(reject);
    });
  },

  getCourseProgress(context, { user_id, course_id }) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(
          `/courses/cursos-completes?user_id=${user_id}&course_id=${course_id}&limit=200`
        )
        .then((response) => {
          if (response.data?.results.length) {
            context.commit("setCourseProgress", response.data.results[0]);
          }
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  async getStartedCourses(context, user_id) {
    let data = [];

    const started_record = await window.axios.get(
      `/courses/cursos-completes?user_id=${user_id}&limit=200`
    );
    const completed_record = await window.axios.get(
      `/courses/cursos-completes?user_id=${user_id}&only_complete=true&limit=200`
    );

    data = data.concat(started_record.data.results);

    completed_record.data.results.forEach((r) => {
      const founded = data.find((c) => c?.course?.id == r?.course?.id);
      if (founded) {
        const index = data.findIndex(({ id }) => id == founded.id);
        data.splice(index, 1, r);
      }
    });

    context.commit("setStartedCourses", data);

    return data;
  },

  getLessonProgress(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/progress/" + id)
        .then((response) => {
          context.commit("setProgress", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  getExam(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/evaluations/evaluation/${id}`)
        .then(({ data }) => {
          context.commit("setCurrentExam", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  getLessons(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/lessons?course_id=" + id)
        .then((response) => {
          context.commit("setLessons", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getLastLessons(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/last-lessons")
        .then((response) => {
          let allLessons = response.data["conferences-videos"];
          Object.keys(allLessons).forEach(
            (key) => delete allLessons[key]["conference"]["cover"]
          );
          allLessons = allLessons.concat(response.data["courses-lessons"]);
          context.commit("setLastLessons", allLessons);
          resolve();
        })
        .catch(reject);
    });
  },

  getRecentlyLaunched(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/lessons-last-months")
        .then((response) => {
          context.commit("setRecentlyLaunched", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getConferences(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/conferences")
        .then((response) => {
          context.commit("setConferences", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getTeachers(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/teachers")
        .then((response) => {
          context.commit("setTeachers", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getMaster(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/teacher/" + id)
        .then((response) => {
          context.commit("setMaster", response.data);
          resolve(response);
        })
        .catch(reject);
    });
  },

  getRankedCourses(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/top10")
        .then((response) => {
          context.commit("setRankedCourses", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  addToMyList(context, course_id) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/courses/mylist/create", {
          course_id,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  removeToMyList(context, { user_id, id }) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/courses/${user_id}/mylist/${id}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  getMyList(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/mylist")
        .then(function (response) {
          context.commit("setMyList", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getHighlightedCategories(context, ids) {
    return Promise.all(
      ids.map((id, index) => {
        if (
          context.state.highlighted_categories.find(
            (category) => category.id == id
          )
        ) {
          return;
        }

        new Promise((resolve, reject) => {
          window.axios
            .get(`/category/${id}/course/`)
            .then((response) => {
              // context.commit("pushHighlightedCategories", {...response.data, id});
              resolve(response.data);
            })
            .catch(reject);

          var categorie = {
            courses: context.state.recently_launched,
            id,
            name: index == 1 ? "Teologia Bíblica" : "Vida Cristã",
          };

          context.commit("pushHighlightedCategories", categorie);
        });
      })
    );
  },

  getConferenceCategories(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/conferences/categories")
        .then((response) => {
          context.commit("setConferenceCategories", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getConferencesHighlighted(context, ids) {
    return Promise.all(
      ids.map((id) => {
        if (
          context.state.highlighted_categories?.find(
            (category) => category.id == id
          )
        ) {
          return;
        }
        new Promise((resolve, reject) => {
          window.axios
            .get(`/conferences/`)
            .then((response) => {
              context.commit("pushConferencesHighlighted", {
                ...response.data.results,
                id,
              });
              resolve(response.data);
            })
            .catch(reject);
        });
      })
    );
  },

  getWatchedCourses(context, user_id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/cursos-completes?user_id=${user_id}&limit=200`)
        .then(({ data }) => {
          resolve(data.results);
        })
        .catch(reject);
    });
  },

  getCompletedCourses(context, user_id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(
          `/courses/cursos-completes?user_id=${user_id}&only_complete=true&limit=200`
        )
        .then(({ data }) => {
          resolve(data.results);
        })
        .catch(reject);
    });
  },

  getAllCompletedCourses(context, user_id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/cursos-completes?user_id=${user_id}`)
        .then(({ data }) => {
          resolve(data.results);
        })
        .catch(reject);
    });
  },

  getAllCompletedLessons(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/lessons-complete")
        .then((response) => {
          let allCompletedLessons =
            response.data["conferences-videos-complete"];
          resolve(allCompletedLessons);
        })
        .catch(reject);
    });
  },

  downloadCertificate(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/certificate/" + id, { responseType: "blob" })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },

  complete(context, { id, grade }) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/courses/curso-complete-add/" + id, { course: id, grade })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
};
